import { FETCH_PARTNERS, FETCH_PARTNERS_SUCCESS, FETCH_PARTNERS_FAILURE } from '../actions/partner-actions'

import { LOGOUT_SUCCESS } from '../actions/auth-actions'

const initialState = {
  loading: false,
  error: null,
  data: []
}

const partnerReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PARTNERS:
      return {
        ...state,
        loading: true,
        error: null,
        data: []
      }
    case FETCH_PARTNERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.data
      }
    case FETCH_PARTNERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error && action.error.message,
        data: []
      }

    case LOGOUT_SUCCESS:
      return initialState

    default:
      return state
  }
}

export default partnerReducer
